export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({
  sm,
  md,
  lg,
}: {
  sm: number;
  md: number;
  lg: number;
}) {
  return {
    "@media (min-width:600px)": {
      fontSize: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(lg),
    },
  };
}

const typography = {
  fontFamily: ["Noto Sans TC", "Noto Sans", "sans-serif"].join(","),
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 80 / 64,
    fontSize: pxToRem(64),
  },
  h2: {
    fontWeight: 700,
    lineHeight: 64 / 48,
    fontSize: pxToRem(48),
  },
  h3: {
    fontWeight: 700,
    lineHeight: 48 / 32,
    fontSize: pxToRem(32),
  },
  h4: {
    fontWeight: 700,
    lineHeight: 36 / 24,
    fontSize: pxToRem(24),
  },
  h5: {
    fontWeight: 700,
    lineHeight: 30 / 20,
    fontSize: pxToRem(20),
  },
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(18),
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 24 / 18,
    fontSize: pxToRem(18),
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 22 / 16,
    fontSize: pxToRem(16),
  },
  body1: {
    fontWeight: 400,
    lineHeight: 24 / 18,
    fontSize: pxToRem(18),
  },
  body2: {
    fontWeight: 400,
    lineHeight: 22 / 16,
    fontSize: pxToRem(16),
  },
  caption: {
    fontWeight: 400,
    lineHeight: 18 / 14,
    fontSize: pxToRem(14),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 18 / 12,
    fontSize: pxToRem(12),
    textTransform: "uppercase",
    letterSpacing: "1.1",
  },
  button: {
    fontWeight: 700,
    lineHeight: 18 / 14,
    fontSize: pxToRem(14),
    textTransform: "capitalize",
  },
} as const;

export default typography;
